export default __webpack_public_path__ + "static/chase_r-bcba91e6a25a5884d656950d6baf5f3f.png";